import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import './Stopwatch.css';
import moment from "moment";

// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRectangleXmark,faFloppyDisk,faSearch, faThumbsDown, faThumbsUp, faCaretDown, faCaretUp, faPlay, faPause, faSave, faRotateLeft, faXmark, faStop } from "@fortawesome/free-solid-svg-icons";

const Stopwatch = forwardRef(({usuario, setShowStopwatch, componentePadre="", isRunning, checklistSaved = null}, ref) => {

    const [timer,setTimer] = useState(checklistSaved?.secondsRunning ? checklistSaved.secondsRunning : 0);

    useImperativeHandle(ref, () => ({
        getChildState: () => timer,
    }));

    //const [isRunning,setIsRunning] = useState(false);

    const formatTime = (timeInSecs) =>{
        const hours = Math.floor(timeInSecs / 3600);
        const minutes = Math.floor((timeInSecs % 3600)/60);
        const seconds = timeInSecs%60;
        return { hours, minutes, seconds };
    }

    useEffect(()=>{
        let interval;
        if(isRunning){
            interval = setInterval(()=>{setTimer((prevTimer) => prevTimer + 1)},1000)
        }else setTimer(0);
        return () => clearInterval(interval);
    },[isRunning])

    useEffect(()=>{
        setTimer(checklistSaved?.secondsRunning ? checklistSaved.secondsRunning : 0);
    },[checklistSaved])

    if(componentePadre == 'RRActivo') return <div className="timerSectionDiv hoursLittle">
            <label>{String(formatTime(timer).hours).padStart(2, "0")}</label>
            <label>:</label>
            <label>{String(formatTime(timer).minutes).padStart(2, "0")}</label>
            <label>:</label>
            <label>{String(formatTime(timer).seconds).padStart(2, "0")}</label>
        </div>
    else return <div style={{display: (checklistSaved != null && checklistSaved.visualizarCrono || componentePadre == 'RRActivo') ? 'flex' : 'none'}} className={`stopwatchDiv ${(componentePadre=='SelectActivo') ? 'noModal' : ''}`}>
        <div className="timerDivsContainer">
            <div className="timerSectionDiv hours">
                <label>{String(formatTime(timer).hours).padStart(2, "0")}</label>
                <label>:</label>
                <label>{String(formatTime(timer).minutes).padStart(2, "0")}</label>
                <label>:</label>
                <label>{String(formatTime(timer).seconds).padStart(2, "0")}</label>
            </div>
        </div>
       
    </div>

});

export default Stopwatch;

/*
    <div className="controlesDiv">
        <button onClick={isRunning ? handleStopRunning : handleStartRunning}>{isRunning ? <FontAwesomeIcon icon={faStop}/> : <FontAwesomeIcon icon={faPlay}/>}</button>
        <button disabled={isRunning || time == 0}><FontAwesomeIcon icon={faSave}/></button>
        <button disabled={isRunning || time == 0} onClick={()=>setTime(0)}><FontAwesomeIcon icon={faRotateLeft}/></button>
        <button disabled={isRunning} onClick={()=>setShowStopwatch(false)}><FontAwesomeIcon icon={faXmark}/></button>
    </div>
*/